import React, { useState, useEffect } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import { useDispatch } from 'react-redux';
import Icon from '../../components/icons';
import moment from 'moment';
import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.css";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import Filter from '../../components/filter';
import ChatAssistant from './chatAssistant';
import './style.css';
import Header from '../../components/header';

const HubWalletAssistant: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
    }, []);



    return (
        <div className="flex">
            <SideMenuBar sideMenuBarClass={'w-64 h-screen w-1/6 bg-white '} />

            <div className="w-full h-screen w-5/6 bg-sky-50 overflow-y-auto" style={{ maxHeight: '100vh' }}>
                <Header />
                <div className="p-8">
                    <h1 className="text-xl font-semibold text-gray-500 mb-2">HubWallet Assistant</h1>

                    <p className="text-sm text-gray-400 mb-6"></p>
                    <div className="flex justify-between mb-5">
                        <div className="flex-1">
                            <ChatAssistant />
                        </div>

                        {/* <div className="w-80 p-6 ml-4">
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default HubWalletAssistant;